<template>
  <transition name="fade" mode="out-in" tag="div" v-on:before-enter="leave" v-on:enter="enter" v-on:leave="leave">
    <li ref="self" @click.prevent="onClick" class="speeddial-btn speeddial-btn__child" v-show="visible">
        <slot></slot>
    </li>
  </transition>
</template>

<script>
export default {
  name: 'SpeedDialItem',
  componentName: 'SpeedDialItem',
  props:{
    initial: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visible() {
      return this.$parent.visible;
    },
    index() {
      return Math.floor(this.$parent.$slots.default.indexOf(this.$vnode) / 2);
    },
    count() {
      return Math.floor(this.$parent.$slots.default.length / 2);
    }
  },
  mounted() {
    this.$nextTick(function () {
      if (this.initial)
        this.$refs.self.click();
    })
  },
  methods: {
    enter(el, done) {
      const index = this.index,
        count = this.count,
        delay = (count * this.$parent.delay) - (index * this.$parent.delay);
     // TODO: change this to requestAnimation
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'scale(1)'
      }, delay);
    },
    leave(el) {
      el.style.opacity = 0
      el.style.transform = 'scale(.3)'
    },
    onClick(el) {
      this.$emit('click', el);
    }
  }
}
</script>
<style type="text/css" scoped>
  .fade-enter-active, .fade-leave-active {
   transition: all .22s;
   transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  .fade-enter-to {
   opacity: 1;
  }
  .fade-leave-to{
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// SpeedDialItem.vue?f20f671e